import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from "@nuxtjs/composition-api";
import ProductCollectionItem from './Product-collection-item.vue'
import type { ComponentPublicInstance } from "vue-demi";
import type { ProductCollectItem } from './Product-collection-item.vue'

interface CollectItem {
  id:string
  name:string
  product_count?:string
  product:ProductCollectItem[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Product-collection',
  props: {
    collection: null
  },
  emits: ["more"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'more',data?:string): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
  collection:CollectItem[],
}




const active = ref(0)
const tabs = ref()
const tab = ref<Array<Element | null | ComponentPublicInstance>>([])

const change = ( i:number )=> { 
  active.value = i;
  (tab.value[i] as HTMLDivElement).scrollIntoView({ behavior: "smooth",inline:'center',block:'nearest'})
}

const moreFunc = () =>{
  emit('more',props.collection[active.value]?.id)
}
const filterCollection = computed(()=>{
  return props.collection.filter(item => item.product.length)
})
const showMore = computed(()=>{ //非平台推荐,产品数量大于4个
  let current = filterCollection.value[active.value]
  return current?.id !== '-9999' && current?.product_count && Number(current?.product_count) > 4
})



return { __sfc: true,props, emit, active, tabs, tab, change, moreFunc, filterCollection, showMore, ProductCollectionItem }
}

})